import { adminMiddleware } from "~/components/_refactored/auth";

export default adminMiddleware;
